import qs, { IStringifyOptions } from 'qs';

type buildUrlProps = {
  url: string;
  params?: { [key: string]: any };
  qsParams?: IStringifyOptions;
};

const buildUrl = ({ url, params, qsParams }: buildUrlProps) => {
  const queryString = qs.stringify(params, qsParams);

  return (queryString ? `${url}?${queryString}` : url).replace(/\/$/, '');
};

export default buildUrl;
